__turbopack_context__.v({
  "checkbox-group": "CheckboxGroupField-module-scss-module__k6mrIW__checkbox-group",
  "checkbox-group--hidden-label": "CheckboxGroupField-module-scss-module__k6mrIW__checkbox-group--hidden-label",
  "checkbox-group__help": "CheckboxGroupField-module-scss-module__k6mrIW__checkbox-group__help",
});
